function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Checkbox",
  width: 16,
  height: 16,
  rx: 4,
  fill: "#fff",
  stroke: "#ededee"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_17._Icon_Small_Minus",
  "data-name": "17. Icon/Small/Minus"
}, /*#__PURE__*/React.createElement("path", {
  id: "minus",
  d: "M11.143,2H.857A.94.94,0,0,1,0,1,.94.94,0,0,1,.857,0H11.143A.94.94,0,0,1,12,1,.94.94,0,0,1,11.143,2Z",
  transform: "translate(2 7)",
  fill: "#878787"
}));

var SvgIconCheckboxMinusReverseColors = function SvgIconCheckboxMinusReverseColors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3._Form_Small_.Resources_Checkbox_Indeterminate",
    "data-name": "3. Form/Small/.Resources/Checkbox/Indeterminate",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckboxMinusReverseColors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-checkbox-minus-reverse-colors.ffe95542.svg";
export { ForwardRef as ReactComponent };